import { Button, ButtonProps } from "antd";

export const AssetWrapperButton = ({
  children,
  ...props
}: { children: React.ReactNode } & ButtonProps) => {
  return (
    <Button
      type="text"
      onClick={(e) => {
        e.stopPropagation();
      }}
      {...props}
      style={{
        position: "relative",
        width: "fit-content",
        height: "fit-content",
        minHeight: 40,
        padding: 0,
        ...props.style,
      }}
    >
      {children}
    </Button>
  );
};
